/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import Button from 'src/components/ts-components/Button'

export interface SelectionActionBarProps {
  count: number
  sending: boolean
  onSend: () => void
}

/** Sticky footer shown once at least one candidate is checked. */
const SelectionActionBar: React.FC<SelectionActionBarProps> = ({
  count,
  sending,
  onSend,
}) => {
  if (count < 1) {
    return null
  }
  return (
    <div css={barStyle}>
      <Button
        text={`Request Player(s) to Play (${count})`}
        variant='primary'
        style={'flex: 0 0 auto; width: auto;'}
        isLoading={sending}
        onClick={onSend}
      />
    </div>
  )
}

export default SelectionActionBar

// Right-aligned, matching the attendance modal's own footer button. No
// border-top here — BaseModal's footer already draws the separator line.
const barStyle = css`
  display: flex;
  justify-content: flex-end;
`
